import PropTypes from 'prop-types';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import { Box, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const MaintenancePage = ({ title, message }) => {
  const theme = useTheme();
  const gradient = `linear-gradient(135deg, ${alpha(theme.palette.secondary.dark, 0.95)}, ${alpha(theme.palette.primary.dark, 0.9)})`;

  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: '100dvh',
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 3, md: 4 },
        py: { xs: 6, md: 8 },
        background: gradient,
        boxSizing: 'border-box'
      }}>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none'
        }}>
        <Box
          sx={{
            position: 'absolute',
            width: 360,
            height: 360,
            borderRadius: '50%',
            background: alpha(theme.palette.secondary.light, 0.25),
            filter: 'blur(120px)',
            top: '-15%',
            left: '-10%'
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            width: 280,
            height: 280,
            borderRadius: '50%',
            background: alpha(theme.palette.primary.light, 0.2),
            filter: 'blur(120px)',
            bottom: '-20%',
            right: '-8%'
          }}
        />
      </Box>

      <Stack
        spacing={3}
        alignItems="center"
        sx={{
          width: 'min(540px, 100%)',
          mx: 'auto',
          textAlign: 'center',
          color: '#fff',
          backgroundColor: alpha('#0f1119', 0.55),
          borderRadius: 4,
          border: '1px solid rgba(255,255,255,0.15)',
          boxShadow: '0 40px 120px rgba(2,6,23,0.5)',
          backdropFilter: 'blur(18px)',
          p: { xs: 4, md: 5 },
          position: 'relative'
        }}>
        <ConstructionRoundedIcon sx={{ fontSize: 56, color: '#fff' }} />
        <Typography variant="h4" component="h1" fontWeight={600}>
          {title || 'We will be right back'}
        </Typography>
        <Typography variant="body1" sx={{ color: alpha('#fff', 0.85), maxWidth: 420 }}>
          {message
            || 'We’re applying a quick update to keep everything running smoothly. Grab a coffee—this won’t take long.'}
        </Typography>

        <Stack spacing={0.5} sx={{ mt: 2 }}>
          <Typography variant="caption" sx={{ color: alpha('#fff', 0.5), letterSpacing: 0.5 }}>
            Last check
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </Typography>
        </Stack>

      </Stack>
    </Box>
  );
};

MaintenancePage.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string
};

export default MaintenancePage;


